import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
    Pagination,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import thirdParty from "./reducers";


class AgencyAnalysis extends React.Component {
    // state = {
    //     selectedRowKeys: [],
    // };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    // reStart = record => {
    //     const {clientId} = record;
    //     this.props.reStart({clientIds: [clientId], action: '7', executeNow: true});
    //     this.props.asyncGet();
    // }

    // edit = record => {
    //     this.props.editShow();
    //     this.props.changeCurrentSelectId(record.clientId);
    // }

    // renderAction = (text, record) => {
    //     // console.log(expanded, record);
    //     return (
    //         <div>
    //             <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
    //                 this.edit(record);
    //             }}>
    //                 编辑
    //             </Button>
    //             <Popconfirm
    //                 title='确认重启'
    //                 okText='确定'
    //                 cancelText='取消'
    //                 onConfirm={() => {
    //                     this.reStart(record);
    //                 }}>
    //                 <Button type="danger" style={{ marginRight: '5px' }} size="small">
    //                     重启
    //                 </Button>
    //             </Popconfirm>
    //         </div>
    //     );
    // };

    onSelectChange = selectedRowKeys => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus, pagination } = this.props;
        let { total, current, pageSize } = pagination;
        let totalPage = Math.ceil(total / pageSize);
        // const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;

        const rowSelection = {
            //selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: '公司名称',
                dataIndex: 'monitoringName',
                key: 'monitoringName',
            },
            {
                title: '出现日期',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: 'url',
                dataIndex: 'url',
                key: 'url',
            },
            {
                title: '请求方式',
                dataIndex: 'requestType',
                key: 'requestType',
            },
            {
                title: '任务ID集合',
                dataIndex: 'eid',
                key: 'eid',
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        defaultExpandAllRows={false}
                        pagination={false}
                    />
                    <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={total}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['40', '80', '120']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.thirdParty.list,
    pagination: state.thirdParty.pagination,
    proxyrepeatinfo: state.thirdParty.proxyrepeatinfo,
    uiStatus: state.thirdParty.uiStatus,
    agentsGroup: state.thirdParty.agentsGroup,
    transferData: state.thirdParty.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    reStart: params => dispatch(reStart(params)),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/monitor/thirdparty/index.js